// extracted by mini-css-extract-plugin
export var content = "GalleryModal-module--content--c4f13";
export var vertical = "GalleryModal-module--vertical--1f9cd";
export var slider = "GalleryModal-module--slider--8dd22";
export var closeButton = "GalleryModal-module--closeButton--ce099";
export var picture = "GalleryModal-module--picture--eff93";
export var image = "GalleryModal-module--image--4d373";
export var caption = "GalleryModal-module--caption--0ac57";
export var name = "GalleryModal-module--name--049a9";
export var year = "GalleryModal-module--year--f3547";